import { GetAdminAccountsRequest, GetAdminAccountsResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminAccountsService {
    public async getAccounts(request: GetAdminAccountsRequest): Promise<GetAdminAccountsResult> {
        return api.admin.getAccounts(request)
    }
}

export const service = new AdminAccountsService()